import React from "react";
import { NavLink } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faAngleRight, faArrowRight } from "@fortawesome/free-solid-svg-icons";
import '../scss/_person_home_status.scss';
import { getUrlPath } from "../functions";
import { useContext } from "react";
import { HotelContext } from "../context/hotel";
import { T } from "react-translator-component";
import { UserContext } from "../context/user";

/**
 * PersonHomeStatus Component
 * 
 * Componente que renderiza una card compacta con la información básica de una persona.
 * Diseño horizontal con:
 * - Un cuadrado a la izquierda con icono de persona
 * - Nombre como título a la derecha
 * - Email y teléfono debajo del nombre
 * - Click en el card navega a /public/
 * 
 * @param {Object} props - Las propiedades del componente
 * @param {Object} props.person - Datos de la persona
 * @param {string} props.person.fullname - Nombre completo de la persona
 * @param {string} props.person.email - Email de la persona
 * @param {string} props.person.phone - Teléfono de la persona
 * @param {string} props.className - (Opcional) Clases CSS adicionales
 * @param {string} props.to - (Opcional) Ruta a la que navegar (default: "/public/")
 * 
 * @example
 * <PersonHomeStatus 
 *   person={{
 *     fullname: "Juan Pérez",
 *     email: "juan@example.com",
 *     phone: "+34 123 456 789"
 *   }}
 * />
 */
const PersonHomeStatus = ({
  person = {},
  className = ""
}) => {
  const { getUrlPath } = useContext(HotelContext);
  const { agent } = useContext(UserContext);
  // Si no hay información de la persona, no renderizar
  if (!person?.fullname) {
    return null;
  }

  return (
    <NavLink to={getUrlPath("/public/")} className="person-home-status-link">
      
      <div className={`person-home-status-card ${className}`} style={{ position: 'relative', display: 'flex', flexDirection: 'row', alignItems: 'stretch', minHeight: 106 }}>
        {/* Avatar Square - Left side */}
        <div className="person-avatar-square">
          <FontAwesomeIcon 
            icon={faUser} 
            className="person-icon"
          />
        </div>

        {/* Info Section - Right side */}
        <div className="person-info-section" style={{ flex: 1 }}>
          <h3 className="person-name-title">{person.fullname}</h3>
          <div className="person-contact-info">
            {person.email && (
              <p className="person-email">
                <span className="contact-label">Email: </span>
                <span className="contact-value">{person.email}</span>
              </p>
            )}
            {person.phone && (
              <p className="person-phone">
                <span className="contact-label">Teléfono: </span>
                <span className="contact-value">{person.phone}</span>
              </p>
            )}
          </div>
        </div>
        <div className="person-home-status-bar">
          <b style={{ fontSize: 11 }}>{T("public.dashboard.go-to-my-reservations")}</b>
          <FontAwesomeIcon style={{ marginLeft: 10, fontSize: 12 }} icon={agent.os === "iOS" ? faAngleRight : faArrowRight} />
        </div>
      </div>
      
    </NavLink>
  );
};

export default PersonHomeStatus;

